import { FC, PropsWithChildren, useMemo } from 'react';

import type { TenantBrandAssets } from '~/core/shared/assets';
import { CORE_BRAND_ASSETS } from '~/core/shared/assets';
import { AssetRepositoryContext } from './AssetRepositoryContext';

type Props = PropsWithChildren<{ assets?: Partial<TenantBrandAssets> }>;

export const AssetRepositoryProvider: FC<Props> = ({ assets, children }) => {
  const value = useMemo(
    () => ({
      assetRepository: { ...CORE_BRAND_ASSETS, ...assets },
    }),
    [assets],
  );

  return (
    <AssetRepositoryContext.Provider value={value}>
      {children}
    </AssetRepositoryContext.Provider>
  );
};
